import React from 'react';
import { CheckCircle, XOctagon } from 'react-feather';
import LoadingStatus from './LoadingStatus';


const SuccessIcon = ({ loading, exists, valid }) => {

    if (loading) {
        return (
            
                <LoadingStatus size={20} />
           
        );
    }
    if (exists === false) {
        return (
            <div className="text-success mt-2 d-flex align-items-center">
            <CheckCircle className='ico-success'/> 
        </div>
        );
    }
    if (exists === true) {
        return (
            <div className="text-success mt-2 d-flex align-items-center">
            <XOctagon className='ico-failure'/> 
        </div>
        );
    }
    if (valid === true) {
        return (
            <div className="text-success mt-2 d-flex align-items-center">
            <XOctagon className='ico-failure'/> 
        </div>
        );
    }
      

};

export default SuccessIcon;